import { QUOTATION_VERSION_SUCCESS } from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case QUOTATION_VERSION_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}